import { render, staticRenderFns } from "./InvoiceTotalValue.vue?vue&type=template&id=cabdbd1e&scoped=true&"
import script from "./InvoiceTotalValue.vue?vue&type=script&lang=js&"
export * from "./InvoiceTotalValue.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTotalValue.vue?vue&type=style&index=0&id=cabdbd1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabdbd1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Projects/Coding/Nhafatura/appfactura-spa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VDivider,VFlex})
